let _getShowAlerts: () => boolean = () => true;

export function setShowAlertsGetter(fn: () => boolean) {
  _getShowAlerts = fn;
}

export function getShowAlerts(): boolean {
  try {
    return _getShowAlerts();
  } catch {
    return true; // safe default
  }
}
